/* eslint-disable @typescript-eslint/no-explicit-any */
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import AreaTitle from "~/components/AreaTitle";
import BaseComponent from "~/components/BaseComponent";
import { ContextualHelpLayout } from "~/components/ContextualHelpLayout/ContextualHelpLayout";
import styles from "./style.module.less";
export default class TaskLayout extends BaseComponent<any, never> {
    render() {
        return (<main>
                <AreaTitle link={links.tasksPage.generateUrl()} title="Tasks"/>
                <ContextualHelpLayout>
                    <div className={styles.container}>{this.props.children}</div>
                </ContextualHelpLayout>
            </main>);
    }
    static displayName = "TaskLayout";
}
